import React from 'react';
import loadable from '@loadable/component';

import { useIntl } from '../../util/reactIntl';

import css from './FallbackPage.module.css';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Create fallback content (array of sections) in page asset format:
export const fallbackSections = error => ({
  sections: [
    {
      sectionType: 'customMaintenance',
      sectionId: 'maintenance-mode',
      // pass possible error to SectionMaintenanceMode component
      error,
    },
  ],
  meta: {
    pageTitle: {
      fieldType: 'metaTitle',
      content: 'Home page',
    },
    pageDescription: {
      fieldType: 'metaDescription',
      content: 'Home page fetch failed',
    },
  },
});

// Note: this microcopy/translation does not come from translation file.
//       It needs to be something that is not part of fetched assets but built-in text
const SectionMaintenanceMode = props => {
  const { sectionId, error } = props;
  const intl = useIntl();
  // 404 means that the landing-page asset was not found from the expected asset path
  // which is defined in config.js
  const is404 = error?.status === 404;
  const title = intl.formatMessage({ id: 'LandingPage.fallbackTitle' });

  return (
    <section id={sectionId} className={css.root}>
      {is404 ? (
        <div className={css.content}>
          <h2>{title}</h2>
          <p>
            {intl.formatMessage({ id: 'LandingPage.fallbackDescriptionLine1' })}
            <br />
            {intl.formatMessage({ id: 'LandingPage.fallbackDescriptionLine2' })}
          </p>
        </div>
      ) : (
        <div className={css.content}>
          <h2>{title}</h2>
          <p>{error?.message}</p>
        </div>
      )}
    </section>
  );
};

// This is the fallback page, in case there's no Landing Page asset defined in Console.
const FallbackPage = props => {
  const { error, ...rest } = props;
  return (
    <PageBuilder
      pageAssetsData={fallbackSections(error)}
      options={{
        sectionComponents: {
          customMaintenance: { component: SectionMaintenanceMode },
        },
      }}
      {...rest}
    />
  );
};

export default FallbackPage;
